import { useEffect } from 'react';
import { useLocation } from 'wouter';
import { useAuth } from '@/hooks/use-auth';

/**
 * Component that handles redirects from the 404.html page
 * Checks for ?redirect= parameter and navigates to that route
 */
export function RedirectHandler() {
  const [currentLocation, setLocation] = useLocation();
  const { user: authUser } = useAuth(); // Import useAuth to check user state

  useEffect(() => {
    // Log component mount for debugging
    console.log('RedirectHandler: Component mounted. Current location:', currentLocation);
    
    // Get the current URL
    const url = new URL(window.location.href);
    console.log('RedirectHandler: Current window.location.href:', window.location.href);
    
    // Check if there's a redirect parameter
    const redirectPath = url.searchParams.get('redirect');
    console.log('RedirectHandler: Parsed redirectPath parameter:', redirectPath);
    
    // Log warning if redirecting to /auth while already logged in
    if (redirectPath === '/auth' && authUser) {
      console.warn('RedirectHandler: Attempting to redirect to /auth while user is already logged in. Current user:', authUser.id);
    }
    
    if (redirectPath && currentLocation !== redirectPath) {
      // Remove the redirect parameter from the URL to prevent loops
      url.searchParams.delete('redirect');
      window.history.replaceState({}, '', url.toString());
      
      // Navigate to the requested path
      console.log(`RedirectHandler: Navigating to ${redirectPath} from redirect parameter. Current location: ${currentLocation}`);
      setLocation(redirectPath);
    } else if (redirectPath) {
      console.log(`RedirectHandler: Already at or redirecting to same path ${redirectPath}. No navigation needed by RedirectHandler.`);
    }
  }, [setLocation, currentLocation, authUser]);

  // This component doesn't render anything
  return null;
}
